import { statementXmlToPlainText } from '../statement-nodes';
import i18next from 'i18next';

const LANGUAGE_CODES: readonly string[] = [
  'en',
  'bg',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'et',
  'fi',
  'fr',
  'ga',
  'hr',
  'hu',
  'it',
  'lt',
  'lv',
  'mt',
  'nl',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sv',
] as const;

export const getLanguageDisplayName = (code: string): string => {
  const normalized = (code || '').trim().toLowerCase();
  const fallback = normalized ? normalized.toUpperCase() : '';
  return i18next.t(`languages.${normalized}`, { defaultValue: fallback });
};

export const getAvailableLanguages = (): string[] => {
  return [...LANGUAGE_CODES];
};

export const copyToClipboard = (text: string): void => {
  navigator.clipboard.writeText(statementXmlToPlainText(text));
};
